import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserProfileContext } from '../context/userProfileContext';

const Authmiddleware = (props) => {
  const { userProfile, isLoading } = useContext(UserProfileContext);

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (!userProfile) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
};

export default Authmiddleware;